import CheckboxInput from "components/Input/CheckboxInput/CheckboxInput";
import React from "react";
import { Controller } from "react-hook-form";
import { formBuilderParams } from "../FormBuilder";
import { useDefaultValueTriggerUpdate } from "../Utils/FormBuilderUtils";

/**
 * @typedef {import("../lib/FormBuilderFieldBuilder").baseFormComponentProps} baseFormComponentProps
 * @typedef {import("../lib/FormBuilderFieldBuilder").baseConfig} baseConfig
 * @typedef {import("../lib/FormBuilderFieldBuilder").checkboxConfig} checkboxConfig
 * @param {baseFormComponentProps & baseConfig & checkboxConfig} props
 */
const FormBuilderCheckbox = ({
  formProps,
  fieldName,
  defaultValue = false,
  defaultValueTriggerUpdate = false,
  label,
  subLabel,
  hideLabel,
  customOnCheckFn,
  disabled = false,
  readOnly = false,
}) => {
  defaultValueTriggerUpdate && useDefaultValueTriggerUpdate({ fieldName, defaultValue, formProps });

  return (
    <Controller
      key={fieldName}
      name={fieldName}
      control={formProps.control}
      defaultValue={defaultValue}
      render={({ field: { value, onChange, ref } }) => (
        <CheckboxInput
          inputRef={ref}
          label={label}
          subLabel={subLabel}
          hideLabel={hideLabel === "removePadding"}
          emptyLabel={hideLabel === "keepPadding"}
          oncheckFn={(e) => {
            const newValue = e.target.checked;
            onChange(newValue);
            if (customOnCheckFn) customOnCheckFn(newValue, formProps);
          }}
          checked={!!value}
          divStyle={formBuilderParams.formItemStyle}
          disabled={disabled}
          readOnly={readOnly}
        />
      )}
    />
  );
};

export default FormBuilderCheckbox;
